module.exports = __webpack_public_path__ + "img/upskill3.2cfebb0b.svg";